{"version":"2.96.0","build":"20261103-2","hash":"6e23a78ccbf734f5ca85eff9dce525aa4a036f92","isDirty":false}